<template>
  <div id="knowledge-detail" v-if="knowledges">
    <!-- parallax -->
    <v-container fluid grid-list-xl pa-0>
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 xs12>
          <v-img
            :aspect-ratio="16 / 9"
            class="grey lighten-2"
            cover
            :lazy-src="require('@/assets/NoPicture.png')"
            :src="
              knowledges.pictureCover ? knowledges.pictureCover : require('@/assets/NoPicture.png')
            "
          >
            <template v-slot:placeholder>
              <v-layout align-center fill-height justify-center ma-0>
                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- knowledge content -->
    <v-container grid-list-xl>
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 xs12>
          <div>
            <div class="caption mb-2 primary--text">{{ `หัวข้อ : ${knowledges.topicName}` }}</div>
            <div class="display-1 font-weight-bold">{{ knowledges.title }}</div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex mt-3 sm6 xs12>
          <span class="knowledge-content" v-html="knowledgeContents"></span>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- example -->
    <v-container grid-list-xl>
      <v-layout align-center justify-center row wrap>
        <v-flex pb-1 sm6 xs12>
          <div class="title font-weight-bold">
            หากคุณมีคำถามอยากถาม
            <span class="caption" style="color:red">{{ errors.first('question') }}</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 sm6 text-xs-right xs12>
          <v-textarea
            class="question-box"
            data-vv-as="textarea"
            data-vv-name="question"
            :error-messages="errors.collect('question')"
            hide-details
            placeholder="คำถามของคุณจะได้รับคำตอบ
พิมพ์คำถาม หรือข้อสงสัยต่อบทเรียนของคุณ"
            rows="4"
            solo
            v-model="question"
            v-validate="'required'"
          ></v-textarea>
          <v-btn
            block
            class="black--text title font-weight-bold"
            @click.prevent="doSubmit()"
            color="#06E59F"
            dark
            depressed
            large
            :loading="loadingSubmit"
            >ส่งคำถาม</v-btn
          >
        </v-flex>
      </v-layout>

      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs12>
          <v-btn
            class="title font-weight-bold"
            @click="doExam(knowledges.idx, knowledges.title)"
            color="yellow accent-2"
            depressed
            large
            >ทำแบบทดสอบวัดความเข้าใจ</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs12>
          <base-banners bannerPositionId="BANNERPOS0000002" pageId="PAGES0000003"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'knowledge-detail',
  data() {
    return {
      loadingSubmit: false,
      question: '',
      knowledgeContents: ''
    }
  },
  computed: {
    knowledgeId() {
      return window.atob(this.$route.params.knowledgeId)
    },
    knowledges() {
      return this.$store.getters['Knowledge/getAll'].filter(item => item.idx == this.knowledgeId)[0]
    }
  },
  beforeCreate() {
    window.scrollTo(0, 0)
  },
  created() {
    this.$store.dispatch('Knowledge/fetch')
    this.getknowledgeContent()
  },
  methods: {
    async getknowledgeContent() {
      try {
        const response = await this.axios.get(`portal/knowledge/content/${this.knowledgeId}`)
        if (response.data.length) {
          this.knowledgeContents = response.data[0].content
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    doExam(knowledgeId) {
      this.$router.push({
        name: 'exam',
        params: {
          knowledgeId: window.btoa(knowledgeId)
        }
      })
    },
    async doSubmit() {
      try {
        const dict = {
          custom: {
            question: {
              required: 'กรุณาระบุคำถาม'
            }
          }
        }
        // or use the instance method
        this.$validator.localize('th', dict)
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.loadingSubmit = !this.loadingSubmit
          // this.$store.dispatch('Question/update', this.question)
          const response = await this.axios.post('portal/knowledge/question/send/', {
            knowledgeId: this.knowledgeId,
            question: this.question
          })
          if (response.data) {
            this.loadingSubmit = !this.loadingSubmit
            this.question = null
            this.$validator.reset()
            const notification = {
              type: 'success',
              message: 'ทางเราได้รับคำถามแล้ว จะรีบตอบโดยเร็ววัน'
            }
            this.$store.dispatch('Notification/add', notification)
          }
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-parallax {
  /* Set a specific height */
  min-height: 200px;
  background-attachment: fixed;
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
